import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import RegistrationsPage from './RegistrationsPage';
import SubmissionListPage from './submissions/SubmissionListPage';
import SubmissionPage from './submissions/SubmissionPage';
import CreateFormPage from './admin/CreateFormPage';
import EditFormPage from './admin/EditFormPage';
import { useIntl } from 'react-intl';
import PageTitle from '../../components/layout/pageTitle/PageTitle';
const RegistrationsLayout: FC = () => {
  const intl = useIntl();
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageTitle title={intl.formatMessage({ id: 'navbar.forms.title' })}></PageTitle>
          <Row>
            <Col xl={12}>
              <Route exact path="/registrations" component={() => <RegistrationsPage />} />
              <Route exact path="/registrations/submissions/:formId/:submissionId" component={SubmissionPage} />
              <Route exact path="/registrations/submissions/:formId" component={SubmissionListPage} />
              <Route exact path="/registrations/admin/create-new-form" component={CreateFormPage} />
              <Route exact path="/registrations/admin/edit-form/:formId" component={EditFormPage} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RegistrationsLayout;
